/**
 * Best-effort device fingerprint (FingerprintJS OSS visitorId).
 *
 * Used as a SECONDARY signal only: bound to the credential at registration and
 * compared at login by the backend. It is spoofable, drift-prone, and not
 * guaranteed unique — the device-bound passkey + one-credential-per-analyst
 * rules are the real "one device" controls. Never throws; resolves to null on
 * failure so callers can proceed (the backend decides how to treat a missing
 * fingerprint).
 *
 * The load()+get() result is memoized so repeated awaits are instant and don't
 * add latency between a user gesture and the WebAuthn ceremony.
 */
import FingerprintJS from "@fingerprintjs/fingerprintjs";

let _promise;

export function getDeviceFingerprint() {
  if (!_promise) {
    _promise = FingerprintJS.load()
      .then((fp) => fp.get())
      .then((res) => res.visitorId)
      .catch(() => null);
  }
  return _promise;
}
